import AdvanceSettings from '../AdvanceSettings';
import DeveloperSettings from '../DeveloperSettings';
import BaseUrl from '../Fields/BaseUrl';
import StoreBasicConfigForm from '../Forms/StoreBasicConfigForm';

const OpenCart = () => (
	<>
		<StoreBasicConfigForm>
			<BaseUrl required />
		</StoreBasicConfigForm>

		<AdvanceSettings fields={['addHour', 'codString']} />

		<DeveloperSettings
			fields={[
				'token',
				'statuses',
				'username',
				'password',
				'apiUrl',
				'productUrl',
				'ignoreNonCodOnPending',
				'paymentNeedConfirm',
				'commentKeys',
				'TrackingUrlType',
				'webhookStatus',
				'lastUpdateDate',
				'productUpdateDate'
			]}
		/>
	</>
);

export default OpenCart;
